import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  GET_OTHER_PATIENT_DAILY_SESSION_FAILURE,
  GET_OTHER_PATIENT_DAILY_SESSION_REQUEST,
  GET_OTHER_PATIENT_DAILY_SESSION_LOADING,
  GET_OTHER_PATIENT_DAILY_SESSION_SUCCESS,
} = dailySessionNotes;

function* getOtherPatientInfo(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_OTHER_PATIENT_DAILY_SESSION_LOADING });

    const response = yield call(
      dailySessionNotesService.getOtherPatientInfo,
      payload?.payload,
      payload.source
    );
    if (response?.status === 200) {
      yield put({ type: GET_OTHER_PATIENT_DAILY_SESSION_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_OTHER_PATIENT_DAILY_SESSION_FAILURE, payload: error });
  }
}

function* getOtherPatientInfoSaga() {
  yield takeEvery(GET_OTHER_PATIENT_DAILY_SESSION_REQUEST, getOtherPatientInfo);
}

export default getOtherPatientInfoSaga;
